"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _saveStagedChangesEpic = _interopRequireDefault(require("./epics/saveStagedChangesEpic"));

var _accountNameModalEpic = _interopRequireDefault(require("./epics/accountNameModalEpic"));

var _closeSsoOnConfirmEpic = _interopRequireDefault(require("./epics/closeSsoOnConfirmEpic"));

var _epics = _interopRequireDefault(require("settings-ui-sdk/SingleSignOn/epics"));

var _epics2 = _interopRequireDefault(require("settings-ui-sdk/TwoFactorAuth/epics"));

var _epics3 = _interopRequireDefault(require("settings-ui-sdk/UnifiedBranding/epics"));

var _epics4 = _interopRequireDefault(require("settings-ui-sdk/MultiCurrency/epics"));

var _epics5 = _interopRequireDefault(require("settings-ui-sdk/Jita/epics"));

var _epics6 = _interopRequireDefault(require("settings-ui-sdk/LoginAuditExports/epics"));

var _epics7 = _interopRequireDefault(require("settings-ui-sdk/CriticalActionsExports/epics"));

var _default = (0, _reduxObservable.combineEpics)(_saveStagedChangesEpic.default, _accountNameModalEpic.default, _closeSsoOnConfirmEpic.default, _epics3.default, _epics.default, _epics4.default, _epics2.default, _epics5.default, _epics6.default, _epics7.default);

exports.default = _default;
module.exports = exports.default;